import api from '@/services/api/api';

export const useNewsBySlug = (slug) => {
  const newsSlug = useQuery(
    ['newsSlug', slug],
    async () => {
      const { data } = await api.news.getNewsBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await newsSlug.suspense();
  });

  return {
    newsSlug,
  };
};
